import { Action, ActionReducer, ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromAuth from '../features/auth/auth.reducer';
import * as fromBusinesses from '../features/businesses/reducers';
import * as fromBusinessDetail from '../features/businesses-detail/business-detail.reducer';
import * as fromEmployeeDetails from '../features/employee-detail/employee-detail.reducer';
import * as fromEmployeeSearch from '../features/employee-search/reducers';
import * as fromTodoSearch from '../features/todos/reducers';
import * as fromPayments from '../features/payment-runs/reducers';
import * as fromPaymentMandate from '../features/payment-mandate/reducers';
import * as fromCreditCard from '../features/add-credit-card/reducers/index.reducer';
import * as fromProductSolution from '../features/product-solutions/reducers/index';
import * as fromLegalEntities from '../features/legal-entities/reducers';

import * as fromRouter from '@ngrx/router-store';
import { InjectionToken } from '@angular/core';
import { storageSync } from '@larscom/ngrx-store-storagesync';
import { storeFormSyncKey, } from '@larscom/ngrx-store-formsync';

export interface State {
  router: fromRouter.RouterReducerState<any>;
  [fromAuth.authFeatureKey]: fromAuth.AuthState;
  [fromBusinesses.businessesFeatureKey]: fromBusinesses.BusinessesState;
  [fromBusinessDetail.businessDetailFeatureKey]: fromBusinessDetail.BusinessDetailMainState;
  [fromEmployeeDetails.employeeDetailFeatureKey]: fromEmployeeDetails.EmployeeDetailMainState;
  // [fromInvites.invitesFeatureKey]: fromInvites.InvitesState;
  [fromEmployeeSearch.employeeSearchFeatureKey]: fromEmployeeSearch.EmployeeSearchMainState;
  [fromTodoSearch.todoFeatureKey]: fromTodoSearch.ToDoMainState;
  // [fromGroups.groupsFeatureKey]: fromGroups.GroupsState;
  // [fromBroadcast.broadcastFeatureKey]: fromBroadcast.BroadCastMainState;
  [fromPayments.paymentsAndStatementsFeatureKey]: fromPayments.PaymentsAndStatementsState;
  // [fromProductSettings.productSettingsFeatureKey]: fromProductSettings.ProductSettingState;
  [fromPaymentMandate.paymentMandateFeatureKey]: fromPaymentMandate.PaymentMandateState;
  [fromCreditCard.addCreditCardFeatureKey]: fromCreditCard.CreditCardState;
  [fromProductSolution.addProductSolutionFeatureKey]: fromProductSolution.ProductSolutionState;
  [fromLegalEntities.legalEntitiesFeatureKey]: fromLegalEntities.LegalEntitiesState;
  // [fromMemberOnBoard.memberOnBoardFeatureKey]: fromMemberOnBoard.MemberOnBoardState;
}

export const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<State, Action>>('Root reducers token', {
  factory: () => ({
    router: fromRouter.routerReducer,
    [fromAuth.authFeatureKey]: fromAuth.reducers,
    [fromBusinesses.businessesFeatureKey]: fromBusinesses.reducers,
    [fromBusinessDetail.businessDetailFeatureKey]: fromBusinessDetail.reducers,
    [fromEmployeeDetails.employeeDetailFeatureKey]: fromEmployeeDetails.reducers,
    // [fromInvites.invitesFeatureKey]: fromInvites.reducers,
    [fromEmployeeSearch.employeeSearchFeatureKey]: fromEmployeeSearch.reducers,
    [fromTodoSearch.todoFeatureKey]: fromTodoSearch.reducers,
    // [fromGroups.groupsFeatureKey]: fromGroups.reducers,
    // [fromBroadcast.broadcastFeatureKey]: fromBroadcast.reducers,
    [fromPayments.paymentsAndStatementsFeatureKey]: fromPayments.reducers,
    // [fromProductSettings.productSettingsFeatureKey]: fromProductSettings.reducers,
    [fromPaymentMandate.paymentMandateFeatureKey]: fromPaymentMandate.reducers,
    [fromCreditCard.addCreditCardFeatureKey]: fromCreditCard.reducers,
    [fromProductSolution.addProductSolutionFeatureKey]: fromProductSolution.reducers,
    [fromLegalEntities.legalEntitiesFeatureKey]: fromLegalEntities.reducers//,
    // [fromMemberOnBoard.memberOnBoardFeatureKey]: fromMemberOnBoard.reducers
  })
});

export const selectRouter = createFeatureSelector<State, fromRouter.RouterReducerState<any>>('router');

export const {
  selectCurrentRoute, // select the current route
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectUrl // select the current url
} = fromRouter.getRouterSelectors(selectRouter);

export function storageSyncReducer(reducer: ActionReducer<State>) {
  // provide all feature states within the features array
  // features which are not provided, do not get synced
  const sync = storageSync<State>({
    features: [
      // save only router state to sessionStorage
      { stateKey: 'router', storageForFeature: window.sessionStorage },

      {
        stateKey: fromAuth.authFeatureKey,
        storageForFeature: window.sessionStorage
      },
      {
        stateKey: storeFormSyncKey,
        storageForFeature: window.sessionStorage
      }
    ],
    storageError: console.error,
    // defaults to localStorage
    storage: window.localStorage
  });

  return sync(reducer);
}

export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === '[Logout] Clear Store') {
      state = undefined;
    }
    return reducer(state, action);
  };
}
